import { DesignData, DesignGetParams } from 'views/StudioSearchProductPage/types';
import apiRequest from 'api/apiRequest';
import endpoints from 'api/endpoints';
import { AppBundle } from 'api/optimalprint-sdk.d';
import fixPhpJSONConvertedObject from 'utils/StudioSearchProductPage/fixPhpJSONConvertedObject';
import { getDesignContentHash } from 'utils/StudioSearchProductPage/getDesignConentHash';
import { cloneDeep } from 'lodash';
import { BundledProduct } from 'store/product/types';

const adjustStudioSelectionDesignStructure = (design: DesignData) => {
  const result = cloneDeep(design) as DesignData;
  try {
    result.spreads[0].layoutSchemaName = 'ss_i1_1';
    result.spreads[0].pages[0].layoutSchemaName = 'ss_i1_1';
    const images = result.spreads[0].pages[0].groups.media;
    if (images) {
      images[0].locked = true;
      images[0].personalizationLocked = true;
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Error adjust studio selection structure');
  }
  return result;
};

export const addToDesignCart = async (customerDesignId: number) => {
  return (await apiRequest(
    endpoints.cartV1DesignAdd,
    {
      quantity: 1,
      customerDesignId,
    },
    'POST',
    'data',
  )) as AppBundle.Api.Response.Cart.V1.IItemAddV1Response;
};

export const addProductToCart = async (
  bundleProduct: BundledProduct,
  customerDesignId: number,
  orderItemId?: number,
) => {
  if (bundleProduct.productId > 0) {
    return (await apiRequest(
      endpoints.cartV1ProductAdd,
      {
        quantity: 1,
        customerDesignId,
        productId: bundleProduct.productId,
        categoryId: bundleProduct.categoryId,
        includeAnalytics: true,
        bundleOwnerOrderItemId: orderItemId,
      },
      'POST',
      'data',
    )) as AppBundle.Api.Response.Cart.V1.ProductAddV1Response;
  }
  return null;
};

export const fetchPublicDesignByProductUid = async (productUid: string, source: string, sourceImageId: number) => {
  const requestParams: DesignGetParams = {
    productUid,
    source,
    sourceImageId,
  };

  try {
    const response = (await apiRequest(
      endpoints.publicDesignV3GetByProductId,
      requestParams,
      'GET',
      'data',
    )) as AppBundle.Api.Response.Design.V3.DesignPublicGetByProductUidV3Response;
    let fixedDesignStructurePhp;
    if (response) {
      const { designStructure: ds } = response;
      fixedDesignStructurePhp = fixPhpJSONConvertedObject(ds);
      if (sourceImageId) {
        fixedDesignStructurePhp = adjustStudioSelectionDesignStructure(fixedDesignStructurePhp);
      }
    }
    return fixedDesignStructurePhp;
  } catch (ex) {
    // eslint-disable-next-line no-console
    console.log('Error fetching design structure');
    return undefined;
  }
};

export const addCustomerDesign = async (
  categoryId: number,
  structure: DesignData,
  encPublicDesignId?: string,
  pID?: number,
) => {
  let response;
  const requestParams = {
    encPublicDesignId,
    categoryId,
    productId: pID,
    structure,
    isDesignCompleted: true,
    contentHash: getDesignContentHash(structure),
    clientPlatform: 5,
  };
  try {
    response = (await apiRequest(
      endpoints.customerDesignV3Add,
      requestParams,
      'POST',
      'data',
    )) as AppBundle.Api.Response.Customer.Design.Design.V3.CustomerDesignAddV3Response;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Cannot add customer design, exception: ', e);
  }

  if (!response) {
    // eslint-disable-next-line no-console
    console.error('Cannot add customer design');
  }
  return response;
};
